import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-assignment-result-cell',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './assignment-result-cell.html',
  styleUrl: './assignment-result-cell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentResultCellComponent {
  readonly resultCount = input<number | null>(null);
  readonly tooltip = input<string | null>(null);
}
